document.addEventListener('DOMContentLoaded', ()=>{
    const menuItems = document.querySelectorAll('.header__menu-item_custom');
    menuItems.forEach(element => {
        element.addEventListener('mouseover', function(){
            for (let i = 0; i < menuItems.length; i++) {
                menuItems[i].classList.remove('is-active');
            }
            this.classList.add('is-active');
        });
        element.addEventListener('mouseleave', function(){
            for (let i = 0; i < menuItems.length; i++) {
                menuItems[i].classList.remove('is-active');
            }
        })
    })
})